import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../common/Loader";
import Error from "../../assets/svg/Error";
import { ModalHeader } from "../common/ModalHeader";
import {
  updateBankInfo,
  updatePaymentModalInit,
} from "../../store/slicers/authSlice";
import { bankInfo } from "../../api/merchant";
import { toast } from "react-hot-toast";
export const InitialPayoutDetails = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [bankDetails, setBankDetails] = useState({});
  const [isEdit, setIsEdit] = useState(false)

  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const showPaymentInit = useSelector((state) => state.auth.showPaymentInit);

  useEffect(() => {
    if (showPaymentInit) {
      handleInit();
    }
  }, [showPaymentInit]);

  const handleInit = async () => {
    setIsLoading(true);
    try {
      const _requestData = { flag: "init" };
      const response = await bankInfo(_requestData);
      if (response.error === 0) {
        setIsLoading(false);
        setBankDetails(response.data.bank_info);
        setBankName(response?.data?.bank_info?.bank_name || "");
        setAccountName(response?.data?.bank_info?.account_name || "");
        setAccountNumber(response?.data?.bank_info?.account_no || "");
      } else {
        handleClose();
        toast(response.error_msg);
      }
    } catch (error) {
      handleClose();
      toast("Failed. Please try again.");
    }
  };

  const handleProceed = async () => {
    setError("");
    if (bankName === "" && accountName === "" && accountNumber === "") {
      setError("Please ensure that all fields are filled in.");
      return;
    }

    setIsLoading(true);
    try {
      const _requestData = {
        flag: "save",
        bank_name: bankName,
        account_name: accountName,
        account_no: accountNumber,
      };
      const response = await bankInfo(_requestData);
      if (response.error === 0) {
        setIsLoading(false);
        dispatch(
          updateBankInfo({
            account_name: accountName,
            account_no: accountNumber,
            bank_name: bankName,
          })
        );
        toast(response.msg);
        handleClose();
      } else {
        setIsLoading(false);
        setError(response.error_msg);
      }
    } catch (error) {
      setIsLoading(false);
      setError("Failed. Please try again.");
    }
  };

  const handleClose = () => {
    setError("");
    setBankName("");
    setAccountName("");
    setAccountNumber("");
    setBankDetails("");
    dispatch(updatePaymentModalInit(false));
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 text-gray-500">
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="bg-white rounded-3xl relative py-6 mx-4 w-500">
        <ModalHeader
          closeable={false}
          title="Merchant Account Update"
          onClick={() => {
            handleClose();
          }}
          type={1}
        />

        <div id="bank" className="px-6 flex flex-col gap-y-2">
          <div> Improved Payout Security </div>
            <div className="text-xs text-gray-400 mb-2">
              To ensure a more secure platform for everyone, adding your payout
              bank details is now required before you can create a listing.
              Ensuring a safer and more reliable platform.
            </div>
          

          <div id="bankName">
            <div
              className={`${
                isEdit && "border"
              } w-full  items-center p-2  mr-2 rounded-xl text-sm`}
            >
              <label htmlFor="bankName" className="px-2 text-xs text-gray-400">
                Bank Name
              </label>
              <div className="flex">
                <input
                  disabled={!isEdit}
                  autoFocus={true}
                  className={`resize-none border-none px-2 outline-none w-full bg-transparent 
    ${!isEdit ? "font-semibold cursor-not-allowed" : ""}`}
                  id="bankName"
                  type="text"
                  placeholder="-"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div id="accountName">
            <div
              className={`${
                isEdit && "border"
              } w-full  items-center p-2  mr-2 rounded-xl text-sm`}
            >
              <label
                htmlFor="accountName"
                className="px-2 text-xs text-gray-400"
              >
                Account Name
              </label>
              <div className="flex">
                <input
                  disabled={!isEdit}
                  className={`resize-none border-none px-2 outline-none w-full bg-transparent 
    ${!isEdit ? "font-semibold cursor-not-allowed" : ""}`}
                  id="accountName"
                  type="text"
                  placeholder="-"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div id="accountNumber">
            <div
              className={`${
                isEdit && "border"
              } w-full  items-center p-2  mr-2 rounded-xl text-sm`}
            >
              <label
                htmlFor="accountNumber"
                className="px-2 text-xs text-gray-400"
              >
                Account Number
              </label>
              <div className="flex">
                <input
                  disabled={!isEdit}
                  placeholder="-"
                  className={`resize-none border-none px-2 outline-none w-full bg-transparent 
    ${!isEdit ? "font-semibold cursor-not-allowed" : ""}`}
                  id="accountNumber"
                  type="text"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="h-3 mt-2">
            {error && (
              <span className="text-xs text-red-500 flex flex-row item-center">
                <Error className="w-3 mr-1 self-center" />
                {error}
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-row space-x-2 px-6">
          {isEdit && (
            <button
              disabled={isLoading}
              className="mt-4 border border-primary-500 px-10 w-full text-primary-500 font-semibold py-4 rounded-xl hover:opacity-90"
              onClick={() => setIsEdit(false)}
            >
              <p className="text-sm">Cancel</p>
            </button>
          )}

          {isEdit ? (
            <button
              className="mt-4 bg-primary-500 px-10 w-full text-white font-semibold py-4 rounded-xl hover:opacity-90"
              onClick={isLoading ? () => {} : handleProceed}
            >
              {isLoading ? <Loader /> : <p className="text-sm">Proceed</p>}
            </button>
          ) : (
            <button
              className="mt-4 bg-primary-500 px-10 w-full text-white font-semibold py-4 rounded-xl hover:opacity-90"
              onClick={() => {
                setIsEdit(true);
              }}
            >
              <p className="text-sm">Update</p>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
